var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAwsLambda(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-27 0 310 310",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,245.262 L16.322,253.423 L19,248.668 L19,59.333 L16.322,55.839 L0,64 L0,245.262",
    fill: "#9D5025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.678,63.57 L16.322,55.839 L16.322,253.423 L47.678,246.121 L47.678,63.57",
    fill: "#F68536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.893,78.604 L166.228,67.007 L240.537,95.785 L220.779,98.362 L143.893,78.604",
    fill: "#6B3A19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.752,230.658 L166.658,242.255 L240.966,213.477 L221.208,210.899 L144.752,230.658",
    fill: "#FBBF93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.336,198.872 L189.423,204.027 L191.667,200 L191.667,110 L189.423,105.235 L150.336,110.389 L150.336,198.872",
    fill: "#9D5025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.651,45.96 L59.705,33.933 L62.333,39 L62.333,270 L59.705,275.329 L35.651,263.302 L35.651,45.96",
    fill: "#9D5025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.671,259.007 L59.705,274.899 L59.705,33.933 L108.671,49.826 L108.671,259.007",
    fill: "#F68536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.772,289.933 L128,309.262 L132,304.667 L132,5.667 L128,0 L89.772,19.329 L89.772,289.933",
    fill: "#9D5025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.919,98.362 L239.678,95.785 L241.375,98.25 L241.375,211 L239.678,213.906 L219.919,211.329 L219.919,98.362",
    fill: "#9D5025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.423,105.235 L189.423,204.456 L230.228,154.631 L189.423,105.235",
    fill: "#F68536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.678,55.839 L128,0 L128,309.262 L256,245.262 L256,64 L239.678,55.839 L239.678,55.839 Z M239.678,214.056 L166.228,235.992 L166.228,73.27 L239.678,95.206 L239.678,214.056 L239.678,214.056 Z",
    fill: "#F68536"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsLambda);
export default __webpack_public_path__ + "static/media/aws-lambda.c186f31641caa1d8dfba92e8049d2d9f.svg";
export { ForwardRef as ReactComponent };